import axios from 'axios';

export type BulkDeleteFn = (ids: number[], setError: (message: string) => void) => Promise<void>;

export const bulkDeletePOItems: BulkDeleteFn = async (
  poItemIDs: number[],
  setError: (message: string) => void
) => {
  try {
    await axios.delete(`/admin/analytics/order-line`, { data: { orderLines: poItemIDs } });
  } catch (error) {
    setError('Failed to delete items.');
  }
};
